import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, Loading, LoadingController, ToastController, ModalController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { TaskUpdatePage } from './../../pages/task-update/task-update';
import moment from 'moment';
import { AngularFireAuth } from 'angularfire2/auth';

@IonicPage()
@Component({
  selector: 'page-task-detail',
  templateUrl: 'task-detail.html',
})
export class TaskDetailPage {
  itemSel: any;
  UsuarioObj: any;
  CoachObj: any;
  loading: Loading;
  userType: number;
  canCalificate: boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public af: AngularFirestore, public alertCtrl: AlertController, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public modalCtrl: ModalController, private FireAuth: AngularFireAuth) {
    this.itemSel = navParams.get('item');
    if (this.itemSel && this.itemSel.idAlumno) {
      this.af.doc("Users/" + this.itemSel.idAlumno).snapshotChanges().subscribe(document => {
        if (document.payload.exists) {
          this.UsuarioObj = document.payload.data();
        }
      });
    }
    if (this.itemSel && this.itemSel.idCoach) {
      this.af.doc("Users/" + this.itemSel.idCoach).snapshotChanges().subscribe(document => {
        if (document.payload.exists) {
          this.CoachObj = document.payload.data();
        }
      });
    }

    this.af.doc("Tasks/" + this.itemSel.id).snapshotChanges().subscribe(data => {
      if (data.payload.exists) {
        const id = data.payload.id;
        const data2 = data.payload.data();
        this.itemSel = { id, ...data2 }
        const date = data.payload.data().dueDate;

        this.canCalificate = new Date(date) <= new Date() ? true : false;
      }
    });

    this.FireAuth.auth.onAuthStateChanged(data => {
      if (data && data.uid) {
        this.af.doc("Users/" + data.uid).snapshotChanges().subscribe(document => {
          if (document.payload.exists) {
            this.userType = document.payload.data() && document.payload.data().type ? document.payload.data().type : 0;
          }
        });
      }
    });
  }
  ionViewDidLoad() { }

  stringDate(_date: any): string {
    let date = _date instanceof Date ? _date : new Date();
    //var date1 = new Date();
   // var timeDiff = Math.abs(date.getTime() - date1.getTime());
   // var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    moment.locale("es");
    // if (diffDays <= 5) {
    //   return moment(date).fromNow();
    // } else {
    //   return moment(date).format("ll");
    // }
    return moment(date).format("l");
  }

  cancel() {
    this.navCtrl.pop();
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  finalizar(check: boolean, id: string) {
    this.presentLoadingCustom();
    this.af.doc("Tasks/" + id).update({ "complete": check, "finishedDate": new Date() }).then(() => {
      ////console.log("Listo");
      this.loading.dismiss();
      this.presentToast("Finalizado correctamente!");
      this.itemSel.complete = check;
    }).catch(error => {
      ////console.log(error);
      this.loading.dismiss();
      this.presentToast("Ha ocurrido un error!");
    });
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }


  presentConfirm(idTask: string) {
    let alert = this.alertCtrl.create({
      title: 'Terminar tarea',
      message: ' ¿Estás seguro que quieres marcar como completada esta tarea?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          handler: () => {
            ////console.log('Cancel clicked');
          }
        },
        {
          text: 'OK',
          handler: () => {
            ////console.log('Buy clicked');
            this.finalizar(this.itemSel && this.itemSel.complete ? false : true, idTask);
          }
        }
      ]
    });
    alert.present();
  }

  updateItem(item: any) {
    let Modal = this.modalCtrl.create(TaskUpdatePage, { "item": item });
    Modal.present();
  }

  presentConfirmDelete(id: string, idSesion: string) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar tarea',
      message: '¿Estas seguro de eliminar tarea?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.deleteItem(id, idSesion);
          }
        }
      ]
    });
    alert.present();
  }

  deleteItem(idDocument: string, idSesion: string) {
    this.presentLoadingCustom();
    this.af.doc("Tasks/" + idDocument).delete().then(() => {
      let arregloTareas: any[];
      ////console.log(idSesion);
      this.af.doc("Sessions/" + idSesion).ref.get().then(document => {
        arregloTareas = document.data() && document.data().tasks ? document.data().tasks : [];
        let index = arregloTareas.indexOf(idDocument);
        if (index > -1) {
          arregloTareas.splice(index, 1);
          this.af.doc("Sessions/" + idSesion).update({ tasks: arregloTareas }).then(() => {
            this.presentToast('Eliminado correctamente');
            this.loading.dismiss();
            this.navCtrl.pop();
          }).catch(error => {
            ////console.log(error);
            this.loading.dismiss();
            this.navCtrl.pop();
            this.presentToast('¡Ha ocurrido un error!');
          });
        } else {
          this.presentToast('Ha ocurrido un error');
          this.loading.dismiss();
          this.navCtrl.pop();
        }
      });
    }).catch(error => {
      ////console.log(error);
      this.loading.dismiss();
      this.navCtrl.pop();
      this.presentToast('¡Ha ocurrido un error!');
    });
  }

}




// WEBPACK FOOTER //
// ./src/pages/task-detail/task-detail.ts